export default __webpack_public_path__ + "static/media/345.551f67cb.jpg";